<template>
  <el-dialog :title="`${category.name} · 每日需求`" :visible="true" @close="$emit('close')" :close-on-click-modal="false" width="min(820px, 95%)">
    <p>每段从起始日生效，到下一段开始前结束。未配置显示“-”，明确 0 表示无需求。</p>
    <el-alert v-if="error" :title="error" type="error" :closable="false" />
    <el-button v-if="error" type="text" @click="load">重新加载</el-button>
    <el-button class="add-demand" type="primary" :disabled="loading || saving || !!form" @click="edit()">新增分段</el-button>
    <el-form ref="form" :model="form || {}" :rules="rules">
      <el-table :data="tableRows" v-loading="loading" border>
        <el-table-column prop="effective_start_date" label="起始日" min-width="220">
          <template slot-scope="scope">
            <el-form-item v-if="isEditing(scope.row)" prop="effective_start_date">
              <el-date-picker v-model="form.effective_start_date" type="date" value-format="yyyy-MM-dd" :editable="false" aria-label="起始日" />
            </el-form-item>
            <span v-else>{{ scope.row.effective_start_date }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="daily_quantity" label="每日需求" min-width="180">
          <template slot-scope="scope">
            <el-form-item v-if="isEditing(scope.row)" prop="daily_quantity">
              <el-input v-model.number="form.daily_quantity" type="number" min="0" max="2147483647" step="1" aria-label="每日需求" />
            </el-form-item>
            <span v-else>{{ scope.row.daily_quantity }}</span>
          </template>
        </el-table-column>
        <el-table-column label="操作" min-width="180">
          <template slot-scope="scope">
            <template v-if="isEditing(scope.row)">
              <el-button type="primary" :loading="saving" @click="save" size="mini">保存</el-button>
              <el-button :disabled="saving" @click="cancel" size="mini">取消</el-button>
            </template>
            <template v-else>
              <el-button type="primary" :disabled="saving || !!form" @click="edit(scope.row)" size="mini">编辑</el-button>
              <el-button type="danger" :disabled="saving || !!form" @click="remove(scope.row)" size="mini">删除</el-button>
            </template>
          </template>
        </el-table-column>
      </el-table>
    </el-form>
  </el-dialog>
</template>

<script>
import { production_options, production_create, production_update, production_delete } from '@/api/getData';
import { productionError } from '@/utils/production';
export default {
  name: 'CategoryDemand',
  props: { category: { type: Object, required: true } },
  data: () => ({ rows: [], loading: false, saving: false, error: '', form: null, rules: { effective_start_date: [{ required: true, message: '请选择起始日', trigger: 'change' }], daily_quantity: [{ required: true, type: 'integer', min: 0, max: 2147483647, message: '请输入 0—2147483647 的整数', trigger: 'change' }] } }),
  computed: {
    tableRows() { return this.form && !this.form.id ? [...this.rows, this.form] : this.rows; }
  },
  created() { this.load(); },
  methods: {
    async load() {
      this.loading = true; this.error = '';
      try { this.rows = await production_options('category_daily_demand', { category_id: this.category.id }); }
      catch (error) { this.error = productionError(error); }
      finally { this.loading = false; }
    },
    edit(row) {
      this.form = row ? { id: row.id, effective_start_date: row.effective_start_date, daily_quantity: row.daily_quantity } : { effective_start_date: '', daily_quantity: 0 };
      this.$nextTick(() => this.$refs.form.clearValidate());
    },
    isEditing(row) { return this.form !== null && this.form.id === row.id; },
    cancel() { this.form = null; this.$refs.form.clearValidate(); },
    async save() {
      if (!await this.$refs.form.validate().catch(() => false)) return;
      this.saving = true;
      try {
        const data = { effective_start_date: this.form.effective_start_date, daily_quantity: this.form.daily_quantity };
        if (this.form.id) await production_update('category_daily_demand', this.form.id, data);
        else await production_create('category_daily_demand', { ...data, category_id: this.category.id });
        this.cancel(); await this.load(); this.$emit('changed');
      } catch (error) { this.$message.error(productionError(error)); }
      finally { this.saving = false; }
    },
    async remove(row) {
      try { await this.$confirm('删除此分段？已有前段将延续至下一有效分段。', '确认删除'); await production_delete('category_daily_demand', row.id); await this.load(); this.$emit('changed'); }
      catch (error) { if (error !== 'cancel' && error !== 'close') this.$message.error(productionError(error)); }
    }
  }
};
</script>

<style scoped>
p, .el-alert { margin-bottom: 16px; }
.add-demand { margin-bottom: 12px; }
.el-form-item { margin: 10px 0 18px; }
.el-date-editor { width: 100%; }
</style>
